import api from '../../../assets/api.js';
import menus from "../../../assets/onboarding/json/menus.json";
import propertySettings from "../../../assets/onboarding/json/property.json";

const types = {
	SET_ONBOARDING_TABS: 'SET_ONBOARDING_TABS',
	SET_ONBOARDING_TABS_STATUS: 'SET_ONBOARDING_TABS_STATUS',
	SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
	SET_PROGRESS_PERCENTAGE: 'SET_PROGRESS_PERCENTAGE',
	SET_MENU_STATUS: 'SET_MENU_STATUS',
	SET_PROPERTY_TABS: 'SET_PROPERTY_TABS',
	SET_ONBOARDING_DATA: 'SET_ONBOARDING_DATA',
	SET_COMPANY_STATUS: 'SET_COMPANY_STATUS',
	SET_LOADER :'SET_LOADER'
}

class Navigation {
	constructor() {
		this.namespaced = true;
		this.state = {
			onboardingTabs: {},
			activeTab: {
			},
			onBoardingTabsStatus: [],
			onboardingProgressPercentage: 0,
			menuStatus: {
				corporate: 'locked',
				property: 'locked'
			},
			propertyTabs: {},
			defaultData: {
				"to": "/onboarding",
				"title": "Onboarding Dashboard",
				"icon": "mdi-earth",
				"status": "",
				"tabName": "OnboardingHome",
				"content": "<p>Welcome to Tenant Inc. and thank you for your partnership in transforming your business as we transform the self-storage industry. My name is Anne Mari DeCoster, Executive Vice President of Tenant Inc.</p><p>Your company’s choice of Tenant Tech tells us that you have metamorphosis in mind. Like us, you want to transform the way you use technology to better serve today’s Amazon trained consumer. That’s what Tenant Tech offers you.</P><p>Metamorphosis begins in a Cocoon, and this is your Cocoon – guiding the transition from your old software to Tenant Inc.’s cutting edge technology.</P><p>Cocoon is like a set up wizard. As you advance from screen to screen, you will enter the corporate and property settings necessary to run your business, culminating with your space mix and tenant data. If you don’t enter an input required in Hummingbird, Cocoon will direct your attention back to it before you can advance. Every step along the way is important. This is how your software is customized to support your individual business choices. The more accurate your input is, the better your needs will be met. </P><p>Every screen includes video and written instructions for each type of setting. To a large extent, you can choose the order in which you enter the data. However, you may from time to time encounter a message letting you know that you cannot enter some data until other inputs are provided. For instance, you can’t enter fee or merchandise information until after you upload your accounting information, so that they can be mapped to the correct GL codes for revenue. </P><p>If you have questions while using Cocoon, please reach out to the Technical Lead you met earlier, in your onboarding meetings.</P><p>Throughout this process, you’ll receive emails from us updating you on your progress, how much time is left till your deadline, and how to stay on track so that you can Go Live on time with Tenant Tech. Remember, you can’t fly until the metamorphosis is complete, by providing all of the inputs requested. </P><p>In addition, while you are entering your business settings into Cocoon, you and your team will be enrolled in Tenant University. In this Learning Management System, you and your managers will learn how to use your new software and technology powerfully, so that you will be ready to fly when you emerge from the Cocoon.</P><p>We have found that operators who go through Tenant University, and all the training opportunities we offer, are ready to take full advantage of the software and be in full flight from day one. Operators who skip the training frustrate their tenants and their owners,  because they don’t know how to use the software. There are no short cuts in this training. The time you require your team to put in will more than justify what you and they get out of it. It is very important to make sure that every member of your team who will use Hummingbird goes through Tenant University and gets the Certificate of Completion at the end. Tenant University will also be there for your new managers, as you hire them.</P><p>We hope you’ll take full advantage of these opportunities, so that your software will be ready, your team will be well trained, and you will be able to soar when you launch into your future –equipped with the best new tech in our industry. We look forward to this adventure and partnership with you! </P>",
				"videoUrl": "6lglpceuft",
				"helpText": "Welcome to Hummingbird - Introduction to Property Onboarding",
			},
			onboardingData: {},
			companyStatus : '',
			menus: menus,
			isLoadedOnboarding:false
		},
			this.getters = {
				getOnboardingTabs: state => state.onboardingTabs,
				getPropertySettingsTabs: state => state.propertySettingsTabs,
				getOnboardingTabStatus: state => state.onBoardingTabsStatus,
				getActiveTab: state => state.activeTab,
				getProgressPercentage: state => state.onboardingProgressPercentage,
				getCorporateSettingStatus: state => state.menuStatus.corporate,
				getPropertySettingStatus: state => state.menuStatus.property,
				getPropertyTabs: state => state.propertyTabs,
				getOnboardingData: state => state.onboardingData,
				getCompanyStatus: state => state.companyStatus,
				getMenus: state => state.menus,
				isLoadedOnboarding:state => state.isLoadedOnboarding
			},
			this.actions = {
				async setOnboardingTabs({commit}) {
        await api.get(this.$app, api.ONBOARDING_GLOSSARY).then(r => {
          r.forEach(el => {
            if(menus.corporate.items.hasOwnProperty([el.id])) {
              menus.corporate.items[el.id].title = el.title;
              menus.corporate.items[el.id].tabName = el.id;
              menus.corporate.items[el.id].content = el.content;
              menus.corporate.items[el.id].helpText = el.help_text;
              menus.corporate.items[el.id].footerNote = el.footer_note;
              menus.corporate.items[el.id].videoUrl = el.video.id;
            } else if(propertySettings.hasOwnProperty([el.id])){
              propertySettings[el.id].title = el.title;
              propertySettings[el.id].tabName = el.id;
              propertySettings[el.id].content = el.content;
              propertySettings[el.id].helpText = el.help_text;
              propertySettings[el.id].footerNote = el.footer_note;
              propertySettings[el.id].videoUrl = el.video.id;
            } else if(menus.hasOwnProperty([el.id])) {
              menus[el.id].title = el.title;
              menus[el.id].tabName = el.id;
              menus[el.id].content = el.content;
              menus[el.id].helpText = el.help_text;
              menus[el.id].footerNote = el.footer_note;
              menus[el.id].videoUrl = el.video.id ? el.video.id : "";
            }
          });
          }).catch(e => {
            console.error(e)
          });
					commit(types.SET_ONBOARDING_TABS, menus)
					commit(types.SET_PROPERTY_TABS, propertySettings)
				},
				setActiveTab({ commit, state }, payload) {
					if (payload) {
						//delete payload['items'];
						commit(types.SET_ACTIVE_TAB, payload)
					} else {
						commit(types.SET_ACTIVE_TAB, state.defaultData)
					}
				},
				async setOnboardingData({ commit, dispatch }) {
					dispatch("setOnboardingTabs");
					await api.get(this.$app, api.ONBOARDING_DATA).then(async (r)  => {
						commit(types.SET_ONBOARDING_DATA, r)
						commit(types.SET_COMPANY_STATUS, r)	
						await dispatch("setOnboardingTabStatus");
					    commit(types.SET_LOADER, true);
					}).catch(e => {
						console.error('[Store Failure]', e)
					});
					
				},
				async setOnboardingTabStatus({ commit, dispatch }) {
					let menuDetails = await api.get(this.$app, api.ONBOARDING + 'menudetails');
					commit(types.SET_ONBOARDING_TABS_STATUS, menuDetails.menuList[0]);
					dispatch('calculateOnboardingPercentage', menuDetails.menuList[0]);
				},
				async updateOnboardingTabStatus({ state, dispatch }, payload) {
					let status = payload.status ? payload.status : 'complete';
					let screenname = payload.screenname ? payload.screenname : state.activeTab.tabName;
					await api.post(this.$app, api.ONBOARDING + "/menudetails", { screentype: payload.type, 'status': status, screenname: screenname }).then(r => {
						dispatch('setOnboardingTabStatus');
					}).catch(e => {
						console.error('[Store Failure]', e)
					});
				},
				calculateOnboardingPercentage({ commit, state }, payload) {
					let corporateCompleted = 0;
					let propertyCompleted = 0;
					let corporateSettingsCount = Object.keys(menus['corporate']['items']).length;
					let propertySettingsCount = Object.keys(propertySettings).length-1;
					payload.forEach(element => {
						(element.screen_type == 'corporate' && element.status == 'complete') ? corporateCompleted++ : (element.screen_type == 'property' && element.status == 'complete') ? propertyCompleted++ : '';
					});
					let progressPercentage = Math.round(((corporateCompleted / corporateSettingsCount) * 50) + ((propertyCompleted / propertySettingsCount) * 50));
					if (state.onboardingData.propertyData && state.onboardingData.propertyData.length) {
						menus['property']['status'] = progressPercentage >= 50 ? '' : 'locked';
						propertySettings['MergeToHummingbird'].status = state.onboardingData.propertyData[0].property_status.includes('active','new') ?  'locked' : '';
					} else {
						menus['property']['status'] = 'locked';
					}
					commit(types.SET_PROGRESS_PERCENTAGE, progressPercentage);
					if (state.onboardingData.propertyData && state.onboardingData.propertyData.length) {
						api.put(this.$app, api.ONBOARDING + "onboarding-property", { id: state.onboardingData.propertyData[0].property_status_id, percentage: progressPercentage });
						
					}

				}
			},
			this.mutations = {
				[types.SET_ONBOARDING_TABS](state, payload) {
					state.onboardingTabs = payload;
				},
				[types.SET_ONBOARDING_TABS_STATUS](state, payload) {
					let completedSettings = [];
					if (payload && payload.length) {
						payload.forEach((e) => {
							if (e.screen_type.toLowerCase() == 'corporate') {
								menus[e.screen_type.toLowerCase()]['items'][e.screen_name].status = e.status;
								e.status == 'complete' ? completedSettings.push(e.screen_name) : ''
							} else if (e.screen_type.toLowerCase() == 'property') {
								propertySettings[e.screen_name].status = e.status;
							} else if (e.screen_type.toLowerCase() == 'mainmenu') {
								state.menuStatus[e.screen_name] = e.status;
							}
							if(state.companyStatus == 'launched') {
								menus.corporate.status = 'locked';
							}
						});
					}
					if (menus && completedSettings.length) {
						Object.keys(menus).forEach((a) => {
							Object.keys(menus[a]['items']).forEach((b) => {
								if (menus[a]['items'][b].status == 'locked' && menus[a]['items'][b]['dependsOn']) {
									let isSubset = menus[a]['items'][b]['dependsOn'].map(x => completedSettings.includes(x));
									isSubset.includes(false) ? '' : menus[a]['items'][b].status = '';
								}
							});
						});
					}
					state.onBoardingTabsStatus = payload;
				},
				[types.SET_ACTIVE_TAB](state, payload) {
					state.activeTab = payload;
				},
				[types.SET_PROGRESS_PERCENTAGE](state, payload) {
					state.onboardingProgressPercentage = payload;
				},
				[types.SET_PROPERTY_TABS](state, payload) {
					state.propertyTabs = payload;
				},
				[types.SET_ONBOARDING_DATA](state, payload) {
					state.onboardingData = payload;
				},
				[types.SET_COMPANY_STATUS](state, payload) {
					let status = payload.company.length ? payload.company[0].status : 'launched';
					state.companyStatus = status;
				},
				[types.SET_LOADER](state, payload) {
					state.isLoadedOnboarding = payload;
				}
			}
	}
}
export default Navigation;
